import { Box, styled } from "@mui/material";

export const InviteUserModalStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  .fields-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`;
